// extracted by mini-css-extract-plugin
module.exports = {"container":"NoticeContainer_container__PO860","info":"NoticeContainer_--info__K4bGS","success":"NoticeContainer_--success__dqkvu"};